import { Button } from '@/components/ui/shadcn/button'
import { RunIcon } from '@/components/ui/icons/icons-new'

interface Props {
  onClick?: () => void
  disabled?: boolean
  loading?: boolean
  className?: string
  size?: 'default' | 'sm' | 'lg'
}

export const RunButton = ({ onClick, disabled, loading, className, size = 'default' }: Props) => {
  return (
    <Button
      variant="primary"
      onClick={onClick}
      disabled={disabled || loading}
      size={size}
      className={className}>
      <RunIcon color="white" />
      {loading ? 'Sending...' : 'Send'}
    </Button>
  )
}
